import { IconButton, Menu, PopoverOrigin } from "@mui/material";
import { ReactNode, useState } from "react";

interface Props {
  anchorOrigin?: PopoverOrigin | undefined;
  buttonContent: string | ReactNode;
  children?: ReactNode;
  transformOrigin?: PopoverOrigin | undefined;
}

export function ButtonMenu({
  anchorOrigin,
  buttonContent,
  children,
  transformOrigin
}: Props): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = !!anchorEl;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const close = (): void => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id="buttonmenu-button"
        aria-controls={open ? "buttonmenu-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{ flexGrow: 0 }}
      >
        {buttonContent}
      </IconButton>

      <Menu
        id="buttonmenu-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={close}
        MenuListProps={{
          "aria-labelledby": "buttonmenu-button"
        }}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        {children}
      </Menu>
    </>
  );
}
